import React, { useState } from 'react';
import { useLang } from '../context/LanguageContext';
import styles from './ContactStrip.module.css';

// Email is split into parts so scrapers can't harvest it as a plain string.
// It's only assembled in the browser at click time — never a raw string in the DOM.
function useObfuscatedEmail(parts) {
  const [revealed, setReveal] = useState(false);
  const email = parts.join('');
  const handleClick = (e) => {
    if (!revealed) {
      e.preventDefault();
      setReveal(true);
      // Small delay so the href is set before the browser acts on it
      setTimeout(() => {
        window.location.href = `mailto:${email}`;
      }, 50);
    }
  };
  return { email: revealed ? email : null, handleClick };
}

export default function ContactStrip({ emailParts, theme = 'dark' }) {
  const { t } = useLang();
  const { email, handleClick } = useObfuscatedEmail(emailParts);

  return (
    <div className={`${styles.strip} ${styles[theme]}`}>
      <p className={styles.label}>{t('contact_cta')}</p>
      <a
        href={email ? `mailto:${email}` : '#'}
        className={styles.email}
        onClick={handleClick}
        rel="noopener noreferrer"
      >
        {email || emailParts[0] + '\u2060' + emailParts[1] + '\u2060' + emailParts[2]}
      </a>
    </div>
  );
}
